// import echarts from "echarts";
import * as echarts from "echarts";
export function loadChart(myChart, data) {
  // 颜色设置
  myChart.setOption({
    title: [
      {
        text: data + "%",
        x: "center",
        top: "center",
        textStyle: {
          fontSize: 13,
          color: "#FFFFFF",
          fontFamily: "DINAlternate-Bold, DINAlternate",
          foontWeight: "500"
        }
      }
    ],
    polar: {
      radius: ["66%", "77%"],
      center: ["50%", "50%"]
    },
    angleAxis: {
      max: 100,
      show: false
    },
    radiusAxis: {
      type: "category",
      show: true,
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    series: [
      {
        name: "",
        type: "bar",
        roundCap: true,
        barWidth: 90,
        showBackground: true,
        backgroundStyle: {
          color: "rgba(7,45,136, .6)"
        },
        data: [data],
        coordinateSystem: "polar",
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: "#00B4EC"
              },
              {
                offset: 1,
                color: "#00B4EC"
              }
            ]),
            shadowBlur: 25,
            shadowColor: "#0897D2"
          }
        }
      },
      {
        name: "",
        type: "pie",
        startAngle: 80,
        radius: ["60%"],
        hoverAnimation: false,
        center: ["50%", "50%"],
        itemStyle: {
          color: "rgba(3,38,129, .1)",
          borderWidth: 2,
          borderColor: "#5370B7"
        },
        data: [100]
      }
    ]
  });
}
